import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  areas: Schema.array().label(''),
  areasSubordinadas: Schema.boolean(),
  responsaveis: Schema.string().label(<FormattedMessage id="responsaveis" />),
  descricao: Schema.string().label(<FormattedMessage id="descricao" />),
  tipoPeriodoDataInicio: Schema.string(),
  dataInicioDe: Schema.string(),
  dataInicioAte: Schema.string(),
  tipoPeriodoDataTermino: Schema.string(),
  dataTerminoDe: Schema.string(),
  dataTerminoAte: Schema.string(),
  tipoIdentificacao: Schema.string().label(
    <FormattedMessage id="labelTipoPesquisa" />
  ),
  status: Schema.string().label(<FormattedMessage id="status" />),
});
